export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5640.ebf30e31.jpg";